module.exports = __webpack_public_path__ + "img/welcome1.0e4e3697.jpg";